
import { styleNumPxToVm as vm } from '@/shared/utils/style-unit';
import { Vue, Component, Prop } from 'vue-property-decorator';

import styles from './index.module.scss';

@Component({ name: 'LoadingSkeleton' })
export default class LoadingSkeleton extends Vue {
  @Prop() private width!: number;

  @Prop() private height!: number;

  @Prop() private radius!: number;

  @Prop() private backgroundColor!: string;

  private render() {
    const {
      width, height, radius = 4, backgroundColor = '#e1e6eb',
    } = this;
    return (
      <div class={styles.loadingSkeleton} style={{ width: `${vm(width)}vw`, height: `${vm(height)}vw`, borderRadius: `${vm(radius)}vw` }}>
        <p style={{ backgroundColor }} />
      </div>
    );
  }
}
